export default "__VITE_ASSET__TcJ95lST__"